import { menu } from 'instantsearch.js/es/widgets';
import { hideWhenNoRefinement } from './searchsync-filter-visibility';
import { getInstance, registerWidget } from './searchsync-create-instance';
import { addFilter } from '@wordpress/hooks';

function initMenuWidget() {
  const tgblAlgoliaDataJSON = window.atob(tgblSearchsyncDataEncoded);
  const tgblAlgoliaData = jQuery.parseJSON(tgblAlgoliaDataJSON);
  
  // Get all elements with menu select class
  const elements = document.querySelectorAll("[data-filter-type='menu']")
  const elementsArray = Array.from(elements)
  
  // Group together menu select elements that share an index
  const elementsGroupedByIndex = elementsArray.reduce((acc, element) => {
    const dataIndexValue = element.getAttribute("data-index");
    if (!acc[dataIndexValue]) {
      acc[dataIndexValue] = [];
    }
    acc[dataIndexValue].push(element);
    return acc;
  }, {});

  // Loop through each index
  for (const dataIndexValue in elementsGroupedByIndex) {
    if (elementsGroupedByIndex.hasOwnProperty(dataIndexValue)) {
      const elementsWithSameIndex = elementsGroupedByIndex[dataIndexValue];
      let search = getInstance(dataIndexValue);

      // Perform actions on elements with the same data-index value
      elementsWithSameIndex.forEach(element => {
        const widgetID = element.getAttribute('data-id')
        const widgetData = tgblAlgoliaData[widgetID]
        const attribute = widgetData.attribute
        let facetMappings = []
        if(widgetData.facet_mapping) {
          facetMappings = transformFacetMappingToDict(widgetData.facet_mapping)
        }

        if ( widgetData.preselected_menu_refinement ) {
          const ns = `tangible/menu/${ dataIndexValue }/${ widgetID }`;
          addFilter(
            'tangible-algolia-preselect-refinement',
            ns,
            (plan) => {
              plan.push({
                indexName: dataIndexValue,
                attribute,
                value: widgetData.preselected_menu_refinement,
                widgetType: 'menu',
              });
              return plan;
            }
          );
        }

        let SearchsyncMenu = ($, search, element) => {
          search.addWidgets([
            menu({
              container: element,
              attribute: attribute, 
              // These used to be menuSelect's class names (root/noRefinementRoot/select/option),
              // evidently copy-pasted from searchsync-menu-select-component.js. But `menu` renders
              // a LIST OF LINKS, not a <select> — it has no select/option elements at all, so two
              // of the four never applied, and the elements it does render (list/item/link/count)
              // kept their default `ais-Menu-*` names, which nothing in this plugin styled. That is
              // why the Menu widget rendered as raw underlined theme anchors at body size.
              // Styled by searchsync-refinement-list-component.scss.
              cssClasses: {
                root: 'tgbl-menu',
                noRefinementRoot: 'tgbl-menu--no-refinement',
                list: 'tgbl-menu__list',
                item: 'tgbl-menu__item',
                selectedItem: 'tgbl-menu__item--selected',
                link: 'tgbl-menu__link',
                label: 'tgbl-menu__label',
                count: 'tgbl-menu__count',
                showMore: 'tgbl-menu__show-more',
                disabledShowMore: 'tgbl-menu__show-more--disabled'
              },
              transformItems(items) {
                return items.map(item => ({
                  ...item,
                  label: facetMappings[item.label] ?? item.label,
                  highlighted: facetMappings[item.label] ?? item.label
                })
              )}
            })
          ]);
          // Nothing to refine → hide the accordion rather than show an empty one.
          hideWhenNoRefinement(search, element, 'tgbl-menu--no-refinement');
          registerWidget(element);
        };
        SearchsyncMenu($, search, element);
      });
    }
  }
}

// TODO: consolidate this somewhere to be re-used by all the widgets which need it
const transformFacetMappingToDict = (facetMappingObject) => {
  const facetDictionary = {};
  Object.values(facetMappingObject).forEach(facet => {
      facetDictionary[facet.facet_value] = facet.new_facet_value_label;
  });
  return facetDictionary;
};

export { initMenuWidget }